import { type RefObject, useEffect, useState } from "react";

/**
 * Returns whether `ref`'s element is currently intersecting the viewport.
 * Starts `true` so anything gated on "off-screen" stays hidden until we know
 * otherwise. Used to reveal the nav's compact audience switch once the hero
 * one scrolls away.
 */
export function useOnScreen(ref: RefObject<Element | null>, rootMargin = "0px"): boolean {
  const [onScreen, setOnScreen] = useState(true);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry) setOnScreen(entry.isIntersecting);
      },
      { rootMargin },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, rootMargin]);

  return onScreen;
}
